const Home = {
  parts: [
    'container'
  ],
  baseStyle: {
    container: {
      bg: 'brandColors.primaryBG', // #F7F5F0
    },
  },
};

export default Home;
